export default __webpack_public_path__ + "static/media/prd_thumbnail_01.0f235a40.png";